import { createSelector } from 'reselect'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'

function isPlacingOrderSelector () {
  return createSelector(
    state => state && state.orders,
    (orders) => !!Object
      .keys(orders.data)
      .find(key => {
        const order = orders.data[key]
        return isNewReduxUtil(order) && isLoadingReduxUtil(order)
      })
  )
}

export {
  isPlacingOrderSelector
}
